import { render } from "./LastStand.vue?vue&type=template&id=14ff2921&scoped=true"
import script from "./LastStand.vue?vue&type=script&lang=js"
export * from "./LastStand.vue?vue&type=script&lang=js"

import "./LastStand.vue?vue&type=style&index=0&id=14ff2921&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\10-candles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ff2921"]])

export default __exports__